import React from 'react';
import {Chip, Stack} from "@mui/material";

interface Option {
    name?: string | null;
    value?: string | null;
}

interface Props {
    options?: Array<Option | null> | null;
    value: string;
    disabled?: boolean;
    onPick: (value: string) => void;
    testId?: string;
}

// Proposal chips under a free-text field — same styling as the contact role
// proposals (contactPersonInputRenderers) and TDAForm's date-preset chips.
const QuickPickChips = ({options, value, disabled, onPick, testId}: Props) => {
    const proposals = (options ?? []).filter((o): o is Option => !!o?.value);
    if (proposals.length === 0) return null;
    return (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{pt: '5px'}}>
            {proposals.map((proposal) => (
                <Chip
                    key={proposal.value!}
                    label={proposal.name || proposal.value}
                    variant={value === proposal.value ? 'filled' : 'outlined'}
                    color={value === proposal.value ? 'primary' : 'default'}
                    size="small"
                    disabled={disabled}
                    onClick={() => onPick(proposal.value!)}
                    data-testid={testId}
                />
            ))}
        </Stack>
    );
};

export default QuickPickChips;
